import {
  DefaultButton,
  DetailsList,
  DetailsListLayoutMode,
  DetailsRow,
  Fabric,
  IColumn,
  IDetailsListProps,
  IDetailsRowStyles,
  IStackTokens,
  Label,
  PanelType,
  SelectionMode,
  Stack,
  Text,
  TextField,
  TooltipHost,
} from "office-ui-fabric-react";
import React from "react";
import {
  getCustomerTempHumidityDetails,
  updateCustomerTempHumidityDetails,
} from "../../../services/customers/CustomerService";
import { Loading } from "../../../services/Loading";
import CustomDrawer from "../../common/CustomDrawer";
import NoDataTile from "../../common/NoDataTile";
import { ToastContext } from "../../common/ToastProvider";
import moment from "moment";
import { childrenGap } from "../../common/Constants";
import {
  mdiArrowDown,
  mdiArrowUp,
  mdiCheckCircleOutline,
  mdiCloseCircleOutline,
  mdiPencilOutline,
} from "@mdi/js";
import { THEME } from "../../../utils/Styles";
import Icon from "@mdi/react";
// import ManageTempRhEditDialog from "./ManageTempRhEditDialog";
import { ITempRhDetails } from "../../../vm";
import { parseJwt, toFixedValue } from "../../../services/UtilService";

export interface ManageTemperatureHumidityDetailsProps {
  handleDialogClose: any;
  data?: any;
  slaMatrix: any;
  customerId: string;
}

const ManageTemperatureHumidityDetails: React.FC<ManageTemperatureHumidityDetailsProps> =
  ({ handleDialogClose, data, slaMatrix, customerId }) => {
    //state
    const [state, setState] = React.useState({
      isLoading: false,
      tempRhDetails: [],
      manageEditDialog: {
        isOpen: false,
        index: undefined,
        data: undefined,
      },
      index: undefined,
      isOnEdit: false,
      tempRhObj: {
        id: "",
        date: new Date(),
        temp: undefined,
        rh: undefined,
        sensorId: "",
      },
    } as {
      isLoading: boolean;
      tempRhDetails: ITempRhDetails[];
      manageEditDialog: {
        isOpen: boolean;
        index?: number;
        data?: any;
      };
      index?: number;
      isOnEdit: boolean;
      tempRhObj: ITempRhDetails;
    });

    //custom hooks
    const { showToast } = React.useContext(ToastContext);

    const tokenData = parseJwt();

    // const wrapStackTokens: IStackTokens = { childrenGap: 16 };

    // const handleClose = () => {
    //   handleDialogClose();
    // };

    //hooks
    React.useEffect(() => {
      const asyncFunc = async () => {
        await getTempRhDetails();
      };
      asyncFunc();
    }, []);

    const getTempRhDetails = async () => {
      setState({ ...state, isLoading: true });
      let result = await getCustomerTempHumidityDetails({
        date: data.actualDate,
        tempRhPageId: data.tempRhPageId
        // floorId: data.floorId,
        // customerId: customerId,
        // quadrantId: data.quadrantId,
        // datacenterId: data.datacenterId,
      });
      if (result?.success) {
        let tempRhDetails: ITempRhDetails[] = [];
        console.log(result.data);
        result.data.data.map((ele: any) => {
          tempRhDetails.push({
            id: ele._id,
            date: ele.date,
            rh: ele.rh,
            temp: ele.temp,
            sensorId: ele.sensorId,
            sensorName: result.data.sensors.find(
              (item: any) => item._id === ele.sensorId
            )?.name,
          });
        });

        setState({
          ...state,
          tempRhDetails,
          isLoading: false,
        });
      } else {
        setState({
          ...state,
          isLoading: false,
        });
        showToast(
          result.message || "Error while getting Temp & Rh details",
          "error"
        );
      }
    };

    // const handleEditDialogOpen = (isOpen: boolean, index?: number) => {
    //   let tempRhDetails = undefined;
    //   if (index !== undefined) {
    //     tempRhDetails = { ...state.tempRhDetails[index] };
    //   }
    //   setState({
    //     ...state,
    //     manageEditDialog: {
    //       isOpen,
    //       index,
    //       data: tempRhDetails,
    //     },
    //   });
    // };

    // const handleEditDialogClose = (data: any) => {
    //   let tempRhDetails = [...state.tempRhDetails];
    //   if (data) {
    //     if (state.manageEditDialog.index !== undefined) {
    //       tempRhDetails[state.manageEditDialog.index] = data;
    //       showToast("Value updated successfully", "success");
    //     }
    //   }
    //   setState({
    //     ...state,
    //     manageEditDialog: {
    //       isOpen: false,
    //       index: undefined,
    //       data: undefined,
    //     },
    //     tempRhDetails,
    //   });
    // };

    const _renderItemColumn = (item: any, index: number, column: IColumn) => {
      switch (column.key) {
        case "actions":
          return (
            <Stack horizontal tokens={childrenGap}>
              {state.isOnEdit && state.index === index ? (
                <React.Fragment>
                  <TooltipHost
                    content={`Save`}
                    id={`saveTempRh`}
                    calloutProps={{ gapSpace: 0 }}
                    styles={{ root: { display: "inline-block" } }}
                  >
                    <span onClick={onUpdateTempRh}>
                      <Icon
                        path={mdiCheckCircleOutline}
                        size={0.8}
                        className="pointer"
                        color="green"
                      />
                    </span>
                  </TooltipHost>
                  <TooltipHost
                    content={`Cancel`}
                    id={`cancelTempRh`}
                    calloutProps={{ gapSpace: 0 }}
                    styles={{ root: { display: "inline-block" } }}
                  >
                    <span
                      onClick={() =>
                        setState({
                          ...state,
                          isOnEdit: false,
                          index: undefined,
                          tempRhObj: {
                            id: "",
                            date: new Date(),
                            temp: undefined,
                            rh: undefined,
                            sensorId: "",
                          },
                        })
                      }
                    >
                      <Icon
                        path={mdiCloseCircleOutline}
                        size={0.8}
                        className="pointer"
                        color="red"
                      />
                    </span>
                  </TooltipHost>
                </React.Fragment>
              ) : (
                <TooltipHost
                  content={`Edit`}
                  id={`editTempRh`}
                  calloutProps={{ gapSpace: 0 }}
                  styles={{ root: { display: "inline-block" } }}
                >
                  <span
                    onClick={() =>
                      setState({
                        ...state,
                        isOnEdit: true,
                        index,
                        tempRhObj: item,
                      })
                    }
                  >
                    <Icon
                      path={mdiPencilOutline}
                      size={0.8}
                      className="pointer"
                      color={THEME.palette.themePrimary}
                    />
                  </span>
                </TooltipHost>
              )}
            </Stack>
          );
        case "temp":
          return (
            <React.Fragment>
              {state.isOnEdit && state.index === index ? (
                <TextField
                  value={String(state.tempRhObj.temp)}
                  type="number"
                  name="temp"
                  onChange={handleChange}
                  className="width-80"
                />
              ) : (
                <React.Fragment>
                  <span
                    className={
                      isTempInThreshold(item.temp) ? "text-danger" : ""
                    }
                  >
                    {/* {item.temp.toFixed(2)} */}
                    {toFixedValue(item.temp)}
                  </span>
                  {isTempInThreshold(item.temp) && (
                    <Icon
                      path={
                        item.temp < slaMatrix.temperature.min
                          ? mdiArrowDown
                          : mdiArrowUp
                      }
                      size={0.5}
                      color="#D62828"
                      style={{ marginBottom: -2 }}
                    />
                  )}
                </React.Fragment>
              )}
            </React.Fragment>
          );
        case "rh":
          return (
            <React.Fragment>
              {state.isOnEdit && state.index === index ? (
                <TextField
                  value={String(state.tempRhObj.rh)}
                  type="number"
                  name="rh"
                  onChange={handleChange}
                  className="width-80"
                />
              ) : (
                <React.Fragment>
                  <span
                    className={
                      item.rh !== "NA" && isRhInThreshold(item.rh)
                        ? "text-danger"
                        : ""
                    }
                  >
                    {/* {item.rh.toFixed(2)} */}
                    {toFixedValue(item.rh)}
                  </span>
                  {item.rh !== "NA" && isRhInThreshold(item.rh) && (
                    <Icon
                      path={
                        item.rh < slaMatrix.humidity.min
                          ? mdiArrowDown
                          : mdiArrowUp
                      }
                      size={0.5}
                      color="#D62828"
                      style={{ marginBottom: -2 }}
                    />
                  )}
                </React.Fragment>
              )}
            </React.Fragment>
          );
        case "date":
          return (
            <Text style={{ fontWeight: 600 }}>
              {moment(item.date).format("hh:mm:ss")}
            </Text>
          );
        default:
          return <span>{column.fieldName ? item[column.fieldName] : ""}</span>;
      }
    };

    const _onRenderRow: IDetailsListProps["onRenderRow"] = (props) => {
      const customStyles: Partial<IDetailsRowStyles> = {};
      if (props) {
        if (props.itemIndex % 2 !== 0) {
          customStyles.root = { backgroundColor: "#F3F3F3" };
        }

        return <DetailsRow {...props} styles={customStyles} />;
      }
      return null;
    };

    // const handleChange = (
    //   event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    //   newValue?: string
    // ) => {
    //   // setFirstTextFieldValue(newValue || "");
    //   setState({
    //     ...state,
    //     tempRhObj: {
    //       ...state.tempRhObj,
    //       temp: parseInt(newValue as string),
    //     },
    //   });
    // };

    const handleChange = (e: any) => {
      setState({
        ...state,
        tempRhObj: {
          ...state.tempRhObj,
          [e.target.name]: e.target.value,
        },
      });
    };

    const onUpdateTempRh = async () => {
      // console.log("temprhobj", state.tempRhObj);
      if (!state.tempRhObj.temp) {
        showToast("Temperature field is required", "error");
      } else if (!state.tempRhObj.rh) {
        showToast("Humidity field is required", "error");
      } else {
        setState({ ...state, isLoading: true });
        let tempRhObj = { ...state.tempRhObj };
        tempRhObj.temp = Number(tempRhObj.temp);
        tempRhObj.rh = Number(tempRhObj.rh);
        let result = await updateCustomerTempHumidityDetails(tempRhObj);
        if (result?.success) {
          let tempRhDetails = [...state.tempRhDetails];
          if (state.index !== undefined) {
            tempRhDetails[state.index].temp = result.data?.temp || 0;
            tempRhDetails[state.index].rh = result.data?.rh || 0;
          }
          setState({
            ...state,
            tempRhDetails,
            tempRhObj: {
              id: "",
              date: new Date(),
              temp: undefined,
              rh: undefined,
              sensorId: "",
            },
            isOnEdit: false,
            index: undefined,
            isLoading: false,
          });
          showToast("Temp & Rh value updated successfully", "success");
        } else {
          setState({ ...state, isLoading: false });
          showToast(
            result?.message || "Error while updating temp & rh",
            "error"
          );
        }
      }
    };

    const isTempInThreshold = (tempValue: number) => {
      if (
        tempValue < slaMatrix.temperature.min ||
        tempValue > slaMatrix.temperature.max
      ) {
        return true;
      } else {
        return false;
      }
    };

    const isRhInThreshold = (rhValue: number) => {
      if (
        rhValue < slaMatrix.humidity.min ||
        rhValue > slaMatrix.humidity.max
      ) {
        return true;
      } else {
        return false;
      }
    };

    // const handleLoading = () => {
    //   setState({ ...state, isLoading: !state.isLoading });
    // };

    return (
      <React.Fragment>
        <CustomDrawer
          title="View Temp & Rh Details"
          handelOpen={true}
          // drawerType={PanelType.large}
          onClose={() => handleDialogClose()}
        >
          {state.isLoading && <Loading />}
          <Stack className="pt-16" tokens={childrenGap}>
            <Stack.Item>
              <Label>
                Date:{" "}
                <span style={{ color: "#135c8a" }}>
                  {moment(data.date).format("DD-MMM")}
                </span>
              </Label>
            </Stack.Item>
            <Stack.Item>
              {state.tempRhDetails && state.tempRhDetails.length > 0 ? (
                <Fabric>
                  <DetailsList
                    items={state.tempRhDetails}
                    columns={
                      ![2, 4, 5].includes(tokenData.role)
                        ? [
                          {
                            key: "date",
                            name: "Time",
                            fieldName: "date",
                            minWidth: 50,
                            maxWidth: 100,
                            isResizable: true,
                          },
                          {
                            key: "sensorName",
                            name: "Sensor Name",
                            fieldName: "sensorName",
                            minWidth: 100,
                            maxWidth: 130,
                            isResizable: true,
                          },
                          {
                            key: "temp",
                            name: "Temperature",
                            fieldName: "temp",
                            minWidth: 80,
                            maxWidth: 130,
                            isResizable: true,
                          },
                          {
                            key: "rh",
                            name: "Humidity",
                            fieldName: "rh",
                            minWidth: 80,
                            maxWidth: 130,
                            isResizable: true,
                          },
                          // {
                          //   key: "actions",
                          //   name: "Actions",
                          //   fieldName: "actions",
                          //   minWidth: 80,
                          //   maxWidth: 130,
                          //   isResizable: true,
                          // },
                        ]
                        : [
                          {
                            key: "date",
                            name: "Time",
                            fieldName: "date",
                            minWidth: 50,
                            maxWidth: 100,
                            isResizable: true,
                          },
                          {
                            key: "sensorName",
                            name: "Sensor Name",
                            fieldName: "sensorName",
                            minWidth: 100,
                            maxWidth: 130,
                            isResizable: true,
                          },
                          {
                            key: "temp",
                            name: "Temperature",
                            fieldName: "temp",
                            minWidth: 80,
                            maxWidth: 130,
                            isResizable: true,
                          },
                          {
                            key: "rh",
                            name: "Humidity",
                            fieldName: "rh",
                            minWidth: 80,
                            maxWidth: 130,
                            isResizable: true,
                          },
                        ]
                    }
                    compact={true}
                    setKey="set"
                    onRenderItemColumn={_renderItemColumn as any}
                    layoutMode={DetailsListLayoutMode.justified}
                    selectionMode={SelectionMode.none}
                    onRenderRow={_onRenderRow}
                  />
                </Fabric>
              ) : (
                <NoDataTile title="No Databases Found"></NoDataTile>
              )}
            </Stack.Item>
            <br />
            <Stack.Item align="end">
              <DefaultButton
                text="Cancel"
                onClick={() => handleDialogClose()}
                className="borderless-btn"
              />
            </Stack.Item>
          </Stack>
          {/* {state.manageEditDialog.isOpen && (
          <ManageTempRhEditDialog
            data={state.manageEditDialog.data}
            handleLoading={handleLoading}
            handleEditDialogClose={(data: any) => handleEditDialogClose(data)}
          />
        )} */}
        </CustomDrawer>
      </React.Fragment>
    );
  };

export default ManageTemperatureHumidityDetails;
